// extracted by mini-css-extract-plugin
module.exports = {"contents-related":"contents-related","bm-section-custom":"bm-section-custom","title":"title"};